import type { Thunk } from 'state/state.common';
import { bdrValuationCalendarsBlackoutDatesRequested } from 'state/valuationDateCalendars/valuationDateCalendars.action';

export function checkValuationDateCalendarsRequestNeededThunk(calendars: string[]): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        valuationDateCalendarsSelector: { getUnknownValuationDateCalendars },
      },
    },
  ) => {
    if (Array.isArray(calendars) && calendars.length > 0) {
      const unknownValuationDateCalendars = getUnknownValuationDateCalendars(getState(), calendars);
      if (unknownValuationDateCalendars.length > 0) {
        dispatch(bdrValuationCalendarsBlackoutDatesRequested(unknownValuationDateCalendars));
      }
    }
  };
}
